import getErrorReduxSelector from 'modules/redux/selectors/get-error'
import { TRAINING_AUTH_DOMAIN } from 'modules/training/modules/app-auth/constants'

function getErrorTrainingAuthSelector () {
  return getErrorReduxSelector(TRAINING_AUTH_DOMAIN)
}

export default getErrorTrainingAuthSelector
